<template>
  <page-outline :title="pageTitle">
    <template slot="primaryActions">
      <app-button
        :text="$t('common.bck')"
        icon="fa-light fa-arrow-left"
        variant="primary"
        @click="goBack">
      </app-button>
    </template>
    <template slot="pageContent">
      <b-container fluid>
        <s3-configuration-form v-model="config" :readonly="!editMode" :mode="mode" :msgType="msgType" :entitiesType="entitiesType"></s3-configuration-form>
      </b-container>
    </template>
    <template slot="bottomActions">
      <app-button
        v-if="mode === 'create' && demo"
        :text="$t('common.sve')"
        icon="fa-light fa-save"
        variant="primary"
        @click="createConfig">
      </app-button>
      <app-button
        v-if="mode === 'details' && editMode === false && canEditConfig && demo"
        :text="$t('administration.edit')"
        icon="fa-light fa-pencil"
        variant="primary"
        @click="editModeActivate">
      </app-button>
      <app-button
        v-if="mode === 'details' && editMode === false && canDeleteConfig && demo"
        :text="$t('rights.delete')"
        icon="fa-light fa-trash"
        variant="danger"
        @click="deleteConfig">
      </app-button>
      <app-button
        v-if="mode === 'details' && editMode === true && demo"
        :text="$t('common.sve')"
        icon="fa-light fa-save"
        variant="primary"
        @click="editConfig">
      </app-button>
    </template>
  </page-outline>
</template>

<script>

import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import AppButton from '@/components/common/AppButton.vue'
import {errorMessageAlert} from '@/helpers/alert'
import Spinner from '@/components/common/spinner.vue'
import S3ConfigurationForm from '@/pages/routing/S3/S3ConfigurationForm.vue'
import moment from "moment/moment"

import {loadPage} from '@/helpers/routing'


export default {
  name: 'S3ConfigurationDetails',
  components: {
    'app-button': AppButton,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner,
    's3-configuration-form': S3ConfigurationForm
  },
  props: {
    mode: {
      type: String,
      default: "create"
    },
    entitiesType: {
      type: String,
      default: "rvm"
    },
    msgType: {
      type: String,
    },
    IdConfigRouting: {
      type: String,
    }
  },
  computed: {
    canDeleteConfig () {
      return this.$engine.firstOn().rights.rightIs('s3config_delete', true)
    },
    canEditConfig () {
      return this.$engine.firstOn().rights.rightIs('s3_config_edit', true)
    },
    pageTitle () {
      return this.mode === "details" ? this.$t('Webheader.s3_details') : this.$t('Webheader.s3_add')
    },
  },
  data () {
    return {
      activateSpinner: false,
      config: {},
      demo: true,
      editMode: false,
      returnUrl: '',
      // returnUrl: this.entitiesType === 'rvm' ? '/entitiessettings/rvm/BICRVM' : `/entitiessettings/${this.entitiesType}/Corporate`,
      savedConfig: [],
      timezone: '+00:00'
    }
  },
  created () {
    this.timezone = moment.tz.guess()
    this.role = this.$route.query.role
    this.type = this.$route.query.type
    this.returnUrl = `/routing/configS3list/${this.msgType}/${this.entitiesType}`
    this.activateSpinner = true

    if (this.mode === 'details') {
      this.savedConfig = this.$engine.firstOn().routing.config.clickedConfig
      this.fillFields()
      this.$engine.firstOn().routing.config.clickedConfig = {}
    } else {
      this.editMode = true
    }

    this.$f7.initPullToRefresh()
    this.activateSpinner = false
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    createConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      if (this.config.sslActive === '1') {
        let paramsControl = {
        selectedVerifications: this.config.controlConfig.selectedVerif
        }

        let paramsCertif = {
          name: this.config.certificateConfig.name,
          certificate: this.config.certificateConfig.certificate,
          type: 'SSL',
          password: this.config.certificateConfig.password,
          passwordVerif: this.config.certificateConfig.passwordVerif,
          startDate: this.config.certificateConfig.startDate,
          endDate: this.config.certificateConfig.endDate,
          deliveredBy: this.config.certificateConfig.deliveredBy,
          deliveredTo: this.config.certificateConfig.deliveredTo,
          commonName: this.config.certificateConfig.cn,
          idPod: this.config.certificateConfig.idPod
        }

        this.$engine.firstOn().security.certificates.create(paramsCertif)
        .then(respCertificate => {
          let paramsPrivateKey = {
            name: that.config.privateKeysConfig.name,
            privateKey: that.config.privateKeysConfig.privateKey,
            password: that.config.privateKeysConfig.password,
            passwordVerif: that.config.privateKeysConfig.passwordVerif,
            type: that.config.privateKeysConfig.type,
            idPod: that.config.privateKeysConfig.idPod
          }
          let params = {
            idCertificat: respCertificate.data.idCertificat
          }

          that.$engine.firstOn().security.private_keys.create(paramsPrivateKey)
          .then(respPrivateKey => {
            params.Host = that.config.host
            params.Port = that.config.port
            params.URI = that.config.uri
            params.SSLMode = that.config.sslActive
            params.Name = that.config.name
            params.idPrivateKey = respPrivateKey.data.idPrivateKey
            params.proxyActive = that.config.proxyActive

            if (that.config.proxyActive){
              params.proxyHost = that.config.proxyHost
              params.proxyPort = that.config.proxyPort
              params.proxyLogin = that.config.proxyLogin
              params.proxyPwd = that.config.proxyPwd
              params.proxyTunnel = that.config.proxyTunnel
              params.proxyConnectOnly = that.config.proxyConnectOnly
            }



            that.$engine.firstOn().routing.config.s3.create(params)
            .then(resp => {
              that.$f7.modal({
                title: that.$t('common.routing.config_added'),
                buttons: [
                  {
                    text: 'OK',
                    onClick: function () {
                      return
                    }
                  }
                ]
              })
              loadPage(that, {url: this.returnUrl})
            })
            .catch(error => {
              errorMessageAlert(error, that)
            })
          })
          .catch(error => {
            errorMessageAlert(error, that)
          })
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_addition_error'))
        })
      } else {
        let params = {
          Host: this.config.host,
          Port: this.config.port,
          URI: this.config.uri,
          SSLMode: this.config.sslActive,
          Name: this.config.name,
          login: this.config.login,
          password: this.config.password
          //idCertificate: respCertificate.data.id DRO 17/07/2023 A METTRE QD VHE A FINI COTE MODDE
          //idPrivateKey: respPrivateKey.data.id
        }

        params.proxyActive = that.config.proxyActive

        if (that.config.proxyActive) {
          params.proxyHost = that.config.proxyHost
          params.proxyPort = that.config.proxyPort
          params.proxyLogin = that.config.proxyLogin
          params.proxyPwd = that.config.proxyPwd
          params.proxyTunnel = that.config.proxyTunnel
          params.proxyConnectOnly = that.config.proxyConnectOnly
        }

        this.$engine.firstOn().routing.config.s3.create(params)
        .then(resp => {
          that.$f7.modal({
            title: that.$t('common.routing.config_added'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: '/routing/configurationList/S3/1'})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_addition_error'))
        })
      }
    },
    deleteConfig () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.routing.config_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdS3: that.savedConfig.IdS3
              }
              that.$engine.firstOn().routing.config.s3.delete(params)
              .then(resp => {
                that.$f7.alert('', that.$t('common.routing.config_deleted'))
                loadPage(that, {url: this.returnUrl})
              })
              .catch(error => {
                errorMessageAlert(error, that)
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }
      let dateBegin
      if (this.savedConfig.Role !== 0 && this.config.BeginDate !== '') {
        dateBegin = moment.tz(this.config.BeginDate, "DD/MM/YYYY H:mm:ss", this.timezone)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss[Z]")
      } else {
        dateBegin = null
      }
      let params = {
        Port: this.config.Port,
        URI: this.config.URI,
        IdS3: this.savedConfig.IdConfigS3,
        Region: this.config.Region,
        AccessKey: this.config.AccessKey,
        SecretKey: this.config.SecretKey,
        BucketName: this.config.BucketName,
        Prefix: this.config.Prefix,
        PrefixArchiving: this.config.PrefixArchiving,
        MinBufferSize: this.config.MinBufferSize,
        MaxBufferSize: this.config.MaxBufferSize,
        BeginDate: dateBegin,
        proxyActive: this.config.proxyActive,
        ForceReOpen: this.config.ForceReOpen,
        Scheme: this.config.Scheme,
        useDualStack: this.config.useDualStack === true ? '1' : '0',
        maxConnections: this.config.maxConnections,
        RequestTimeoutMs: this.config.RequestTimeoutMs,
        ConnectTimeoutMs: this.config.ConnectTimeoutMs,
        enableTcpKeepAlive: this.config.enableTcpKeepAlive === true ? '1' : '0',
        Active: this.config.enableActive === true ? '1' : '0',
        tcpKeepAliveInvervalMs: this.config.tcpKeepAliveInvervalMs,
        lowSpeedLimit: this.config.lowSpeedLimit,
        VerifySSL: this.config.VerifySSL === true ? '1' : '0',
        FollowRedirects: this.config.FollowRedirects,
        DisableExpectHeader: this.config.DisableExpectHeader === true ? '1' : '0',
        EnableClockSkewAdjustement: this.config.EnableClockSkewAdjustement === true ? '1' : '0',
        enableHostPrefixInfection: this.config.enableHostPrefixInfection === true ? '1' : '0',
        enableEndpointdiscovery: this.config.enableEndpointdiscovery === true ? '1' : '0',
        caPath: this.config.caPath,
        caFile: this.config.caFile,
        requestChecksumCalculation: this.config.requestChecksumCalculation,
        responseChecksumValidation: this.config.responseChecksumValidation,
        useVirtualAddressing: this.config.useVirtualAddressing === true ? '1' : '0',
        disableMultiRegionAccessPoints: this.config.disableMultiRegionAccessPoints === true ? '1' : '0',
        useArnRegion: this.config.useArnRegion === true ? '1' : '0',
        payloadSigningPolicy: this.config.payloadSigningPolicy,
        disableS3ExpressAuth: this.config.disableS3ExpressAuth === true ? '1' : '0',
      }

      if (that.config.proxyActive){
        params.proxyScheme = that.config.proxyScheme
        params.proxyPort = that.config.proxyPort
        params.proxyLogin = that.config.proxyLogin
        params.proxyPwd = that.config.proxyPwd
        params.proxyHost = that.config.proxyHost
      }
      this.$engine.firstOn().routing.config.s3.edit(params)
          .then(resp => {
            that.$f7.modal({
              title: this.$t('common.routing.config_edited'),
              buttons: [
                {
                  text: 'OK',
                  onClick: function () {
                    return
                  }
                }
              ]
            })
            loadPage(that, {url: this.returnUrl})
          })
          .catch(e => {
            errorMessageAlert(e, that)
            this.okMessageBox(this.$t('common.routing.config_edition_error'))
          })
    },
    editModeActivate () {
      this.editMode = true
    },
    fillFields () {
      this.config.ConfigName = this.savedConfig.ConfigName
      this.config.AccessKey = this.savedConfig.AccessKey
      this.config.BeginDate = this.savedConfig.BeginDate
      this.config.BucketName = this.savedConfig.BucketName
      this.config.BeginDate = moment(this.savedConfig.BeginDate).tz(this.timezone).format("DD/MM/YYYY H:mm:ss") == 'Invalid date'? '':moment(this.savedConfig.BeginDate).tz(this.timezone).format("DD/MM/YYYY H:mm:ss")
      this.config.EndDate = moment(this.savedConfig.EndDate).tz(this.timezone).format("DD/MM/YYYY H:mm:ss") == 'Invalid date'? '':moment(this.savedConfig.EndDate).tz(this.timezone).format("DD/MM/YYYY H:mm:ss")
      this.config.IdS3 = this.savedConfig.IdConfigS3
      this.config.OnlyFile = this.savedConfig.OnlyFile
      this.config.Port = this.savedConfig.Port
      this.config.Prefix = this.savedConfig.Prefix
      this.config.PrefixArchiving = this.savedConfig.PrefixArchiving
      this.config.Region = this.savedConfig.Region
      this.config.SecretKey = this.savedConfig.SecretKey
      this.config.URI = this.savedConfig.URI
      this.config.MinBufferSize = this.savedConfig.MinBufferSize
      this.config.MaxBufferSize = this.savedConfig.MaxBufferSize
      this.config.Role = this.savedConfig.Role
      this.config.proxyActive = this.savedConfig.proxyActive
      this.config.proxyScheme = this.savedConfig.proxyScheme
      this.config.proxyPort = this.savedConfig.proxyPort
      this.config.proxyLogin = this.savedConfig.proxyLogin
      this.config.proxyPwd = this.savedConfig.proxyPwd
      this.config.proxyHost = this.savedConfig.proxyHost
      this.config.ForceReOpen = this.savedConfig.ForceReOpen
      this.config.Scheme = this.savedConfig.Scheme
      this.config.useDualStack = this.savedConfig.useDualStack === '1' ? true : false
      this.config.maxConnections = this.savedConfig.maxConnections
      this.config.RequestTimeoutMs = this.savedConfig.RequestTimeoutMs
      this.config.ConnectTimeoutMs = this.savedConfig.ConnectTimeoutMs
      this.config.enableTcpKeepAlive = this.savedConfig.enableTcpKeepAlive === '1' ? true : false
      this.config.enableActive = this.savedConfig.Active === '1' ? true : false
      this.config.tcpKeepAliveInvervalMs = this.savedConfig.tcpKeepAliveInvervalMs
      this.config.lowSpeedLimit = this.savedConfig.lowSpeedLimit
      this.config.VerifySSL = this.savedConfig.VerifySSL === '1' ? true : false
      this.config.FollowRedirects = this.savedConfig.FollowRedirects
      this.config.DisableExpectHeader = this.savedConfig.DisableExpectHeader === '1' ? true : false
      this.config.EnableClockSkewAdjustement = this.savedConfig.EnableClockSkewAdjustement === '1' ? true : false
      this.config.enableHostPrefixInfection = this.savedConfig.enableHostPrefixInfection === '1' ? true : false
      this.config.enableEndpointdiscovery = this.savedConfig.enableEndpointdiscovery === '1' ? true : false
      this.config.caPath = this.savedConfig.caPath
      this.config.caFile = this.savedConfig.caFile
      this.config.requestChecksumCalculation = this.savedConfig.requestChecksumCalculation
      this.config.responseChecksumValidation = this.savedConfig.responseChecksumValidation
      this.config.useVirtualAddressing = this.savedConfig.useVirtualAddressing === '1' ? true : false
      this.config.disableMultiRegionAccessPoints = this.savedConfig.disableMultiRegionAccessPoints === '1' ? true : false
      this.config.useArnRegion = this.savedConfig.useArnRegion === '1' ? true : false
      this.config.payloadSigningPolicy = this.savedConfig.payloadSigningPolicy
      this.config.disableS3ExpressAuth = this.savedConfig.disableS3ExpressAuth === '1' ? true : false
    },
    formHasError () {
      if (this.config.Region === undefined || this.config.Region.length === 0) {
        this.okMessageBox(this.$t('common.routing.region_missing'))
        return true
      }
      if (this.config.URI === undefined || this.config.URI.length === 0) {
        this.okMessageBox(this.$t('common.routing.uri_missing'))
        return true
      }
      if (this.config.AccessKey === undefined || this.config.AccessKey.length === 0) {
        this.okMessageBox(this.$t('common.routing.access_key_missing'))
        return true
      }
      if (this.config.SecretKey === undefined || this.config.SecretKey.length === 0) {
        this.okMessageBox(this.$t('common.routing.secret_key_missing'))
        return true
      }
      if (this.config.Scheme === undefined || this.config.Scheme.length === 0) {
        this.okMessageBox(this.$t('common.routing.scheme_missing'))
        return true
      }
      if (this.config.maxConnections === undefined || this.config.maxConnections.length === 0) {
        this.okMessageBox(this.$t('common.routing.max_connections_missing'))
        return true
      }
      if (this.config.RequestTimeoutMs === undefined || this.config.RequestTimeoutMs.length === 0) {
        this.okMessageBox(this.$t('common.routing.request_timeout_ms_missing'))
        return true
      }
      if (this.config.ConnectTimeoutMs === undefined || this.config.ConnectTimeoutMs.length === 0) {
        this.okMessageBox(this.$t('common.routing.connect_timeout_ms_missing'))
        return true
      }
      if (this.config.enableTcpKeepAlive === true && (this.config.tcpKeepAliveInvervalMs === undefined || this.config.tcpKeepAliveInvervalMs.length === 0)) {
        this.okMessageBox(this.$t('common.routing.tcp_keep_alive_inverval_ms_missing'))
        return true
      }
      if (parseInt(this.config.tcpKeepAliveInvervalMs, 10) < 15000) {
        this.okMessageBox(this.$t('common.routing.tcp_keep_alive_inverval_ms_invalid'))
        return true
      }
      if (this.config.lowSpeedLimit === undefined || this.config.lowSpeedLimit.length === 0) {
        this.okMessageBox(this.$t('common.routing.low_speed_limit_missing'))
        return true
      }
      if (this.config.VerifySSL === undefined || this.config.VerifySSL.length === 0) {
        this.okMessageBox(this.$t('common.routing.verify_ssl_missing'))
        return true
      }
      if (this.config.FollowRedirects === undefined || this.config.FollowRedirects.length === 0) {
        this.okMessageBox(this.$t('common.routing.follow_redirects_missing'))
        return true
      }
      try {
        new URL(this.config.URI)
      } catch (e) {
        this.okMessageBox(this.$t('common.routing.uri_invalid'))
        return true
      }
      if (this.config.proxyActive === '1' && this.config.proxyHost.length !== 0) {
        try {
          new URL(this.config.proxyHost)
        } catch (e) {
          this.okMessageBox(this.$t('common.routing.proxy_host_invalid'))
          return true
        }
      }

      return false
    },
    goBack () {
      loadPage(this, {url: this.returnUrl})
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}
</script>
